<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="part01" epub:type="part" role="doc-part">
<header><h1 class="h1" id="part01"><span aria-label=" Page 9. " epub:type="pagebreak" id="page_9" role="doc-pagebreak">P<span class="small">ART</span> O<span class="small">NE</span><br/> <span class="ch-tit">WHO AM I?</span></span></h1></header>
<span aria-label=" Page 10. " epub:type="pagebreak" id="page_10" role="doc-pagebreak">
</span></section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?856a7b6a